import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=387d5c8c&"
import script from "./HelpIcon.vue?vue&type=script&lang=js&"
export * from "./HelpIcon.vue?vue&type=script&lang=js&"
import style0 from "./HelpIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports